module.exports = __webpack_public_path__ + "img/coreintercomDesk.2ca14de9.png";